import React from "react";

export const WeatherSettings = (props) => {
    const { location, setProps } = props;

    return (<div>
        <p className="text-sm text-gray-700">Das Wetter-Widget hat keine Einstellmöglichkeiten. Für den Standort der Wettervorhersage wird der Standort des Displays verwendet.</p>
        {/* <input type="text" value={location ? location : ''} onChange={e => setProps({ location: e.target.value })} /> */}
    </div>)
}